import { render } from "./Radio.vue?vue&type=template&id=6d89cb62&scoped=true&ts=true"
import script from "./Radio.vue?vue&type=script&lang=ts"
export * from "./Radio.vue?vue&type=script&lang=ts"

import "./Radio.vue?vue&type=style&index=0&id=6d89cb62&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Link\\Documents\\MCOM\\mcom-agri-origin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d89cb62"]])

export default __exports__